import { Tokens } from '~/utils/constants';
import { BigNumber } from 'bignumber.js';
import { formatEther } from 'ethers';

export default () => {
  const { blockchain } = useEnvs();
  const { saleAmount, liquidityAmount, tokenMaxTotalSupply, totalStake, availableTokens, soldAmount, totalClaimed } =
    useTokensReader();

  const isLoading = ref(false);
  const saleAmountRef = ref(0);
  const soldAmountRef = ref(0);
  const totalClaimedRef = ref(0);
  const liquidityCurrentAmountRef = ref(0);
  const maxTotalSupplyRef = ref(0);
  const totalStakedRef = ref(0);
  const distributionLeftRef = ref(0);
  const distributedRef = ref(0);

  const updateData = async (token: Tokens) => {
    isLoading.value = true;

    try {
      const distributionFond = await tokenMaxTotalSupply(Tokens.pearl).then((res) => formatEther(res || 0));

      const [
        tokenSaleAmount,
        tokenSoldAmount,
        totalClaimedAmount,
        tokenLiquidityCurrentAmount,
        tokenMaxTotalSupplyValue,
        tokenTotalStaked,
        tokenTreasuryBalance
      ] = await Promise.allSettled([
        saleAmount(),
        soldAmount(),
        totalClaimed(),
        liquidityAmount(),
        tokenMaxTotalSupply(),
        totalStake(),
        availableTokens(blockchain.contracts.treasury, blockchain.contracts[token].addresses.contract)
      ]).then((results) => {
        return results.map((res) => (res.status === 'fulfilled' ? res.value : 0));
      });

      saleAmountRef.value =
        token === Tokens.pearl
          ? new BigNumber(tokenSaleAmount.toString()).integerValue().toNumber()
          : new BigNumber(tokenSaleAmount.toString()).multipliedBy(2).toNumber();

      soldAmountRef.value = new BigNumber(tokenSoldAmount.toString()).integerValue().toNumber();
      totalClaimedRef.value = new BigNumber(totalClaimedAmount.toString()).integerValue().toNumber();
      liquidityCurrentAmountRef.value = new BigNumber(tokenLiquidityCurrentAmount.toString()).integerValue().toNumber();
      maxTotalSupplyRef.value = new BigNumber(formatEther(tokenMaxTotalSupplyValue)).integerValue().toNumber();
      totalStakedRef.value = new BigNumber(tokenTotalStaked.toString()).integerValue().toNumber();
      distributionLeftRef.value = Math.min(BigNumber(distributionFond).toNumber(), Number(tokenTreasuryBalance));
      distributedRef.value = BigNumber(distributionFond).minus(distributionLeftRef.value).integerValue().toNumber();
    } catch (err) {
      console.log('err: ', err);
    } finally {
      isLoading.value = false;
    }
  };

  return {
    isLoading,
    updateData,
    saleAmount: saleAmountRef,
    soldAmount: soldAmountRef,
    totalClaimed: totalClaimedRef,
    liquidityCurrentAmount: liquidityCurrentAmountRef,
    maxTotalSupply: maxTotalSupplyRef,
    totalStaked: totalStakedRef,
    distributionLeft: distributionLeftRef,
    distributed: distributedRef
  };
};
